module.exports = __webpack_public_path__ + "static/lab_members-25979946fdb3e78cb7bca0bcc5fd30bb.jpg";